module.exports = __webpack_public_path__ + "static/media/close-black.1da3c657.svg";